import {
  WithStyles,
  createStyles,
  Grid,
  Typography,
  Checkbox,
  FormControl,
  Avatar,
  Button,
} from "@material-ui/core";
import _ from "lodash";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withStyles } from "@material-ui/core/styles";
import { dateService, MyPATLink } from "../../common";
import { capitalize } from "lodash";

import React, { Component } from "react";
import ACLService from "../../acl/services/aclService";

const styles = (theme: Theme) =>
  createStyles({
    notificationInfo: {
      background:
        "linear-gradient(91.97deg, rgba(245, 249, 255, 0.2) 16.85%, rgba(245, 249, 255, 0.16) 56.7%, rgba(190, 216, 255, 0.2) 92.79%), #FFFFFF",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      borderRadius: 8,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 50px 10px 22px",
    },
    heading: {
      fontSize: 20,
      fontWeight: 600,
      color: "#333",
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea!important",
      border: "1px solid #1d7dea !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    checkBoxElement: {
      padding: "0px 7px",
      top: 0,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 4,
      margin: "-4px 14px 0px 16px",
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
      '& span:nth-child(1)': {
        width: 24,
        zIndex: 9
      }
    },
    checkBoxListElement: {
      padding: "0px 7px",
      top: 8,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 4,
      margin: "-4px 14px 0px 16px",
      "& input": {
        zIndex: 1,
      },
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
    },

    checkboxLabel: {
      fontSize: 18,
      color: "#363636",
    },
    formControlLabel: {
      marginBottom: 6,
    },
    mtb20: {
      marginTop: 20,
      marginBottom: 20,
    },
    textRight: {
      textAlign: "right",
    },
    textCenter: {
      textAlign: "center",
    },
    cardContainer: {
      background: "#FFFFFF",
      borderRadius: 8,
      padding: 15,
      marginBottom: "12px",
      minWidth: "100%",
    },
    Avtar: {
      background: "#6267E0",
      color: "#F5F4F4",
      marginTop: 0,
      marginRight: 6,
      marginBottom: 6,
      marginLeft: 18,
      textTransform: "uppercase",
    },
    userName: {
      fontSize: 16,
      fontWeight: 700,
      color: "#333",
      textTransform: "capitalize",
    },
    userType: {
      fontSize: 12,
      fontWeight: 600,
      color: "#666",
      padding: "5px 8px",
      background: "rgba(153, 153, 153, 0.1)",
      borderRadius: "3px",
      margin: "0 10px",
    },
    msgTime: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
    },
    mb15: {
      marginBottom: "15px",
    },
    msgDetail: {
      fontSize: 16,
      fontWeight: 400,
      color: "#666",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      width: '95%',
      "& p": {
        margin: 0,
      },
    },
    CTA: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1d7dea",
      cursor: "pointer",
      "& img": {
        marginLeft: "8px",
        verticalAlign: "middle",
      },
    },
    status: {
      fontSize: 14,
      fontWeight: 400,
      color: "#666",
    },
    minHeight91: {
      minHeight: "91px",
      flexDirection: "column",
      alignItems: "flex-end",
      justifyContent: "space-between",
    },
    disabledBox: {
      opacity: 0.5,
      cursor: "not-allowed"
    },
    mr15:{
      marginRight: 15,
    },
    flex1:{
      flex: 1,
    }
  });

interface NotificationListingProps extends WithStyles<typeof styles> {
  classes: any;
  review: any;
  viewIndex: number;
  currentPageNumber: number;
  challengeId: string;
  checkedChallenges: string[];
  selectAllChallenges: boolean;
  onViewFull: (index: number) => void;
  checkBoxClicked: (id : string) => void;
}
interface NotificationListingStates {}

class NotificationListing extends Component<
  NotificationListingProps,
  NotificationListingStates
> {
  getRandomColourClass = () => {
    const { classes } = this.props;
    const randomNo = Math.floor(Math.random() % 2);
    if (randomNo === 0) {
      return classes.purpleColor;
    }
    return classes.greenColor;
  };

  isCheckBoxSelected = () => {

	if (this.props.selectAllChallenges || this.props.checkedChallenges.length && this.props.checkedChallenges.includes(this.props.challengeId)) {
		return true;
	}
	return false;
  };

  checkBoxChecked = (e: any, checked: boolean) => {
    this.props.checkBoxClicked(this.props.challengeId);
  };

  printCapitaliseString = (status: string) => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  render() {
    const { classes, viewIndex, onViewFull } = this.props;
    const { review } = this.props;
    return (
      <>
        <Grid item className={classes.cardContainer}>
          <Grid container justify="space-between" alignItems="flex-start">
            <Grid item className={classes.flex1}>
              <Grid container justify="flex-start" alignItems="flex-start">
                <Grid item className={classes.mr15}>
                  <Grid container justify="flex-start" alignItems="flex-start">
                    <Checkbox
                      classes={{
                        root: classes.checkBoxListElement,
                        checked: classes.checkedCheckbox,
                        colorPrimary: classes.primaryColor,
                        disabled: classes.disabledBox,
                      }}
                      disabled={this.props.selectAllChallenges}
                      checked={this.isCheckBoxSelected()}
                      onChange={this.checkBoxChecked}
                      color="primary"
                    />
                    <Avatar className={classes.Avtar}>
                      <Grid
                        className={[
                          classes.profileImg,
                          this.getRandomColourClass(),
                        ].join(" ")}
                      >
                        <span>{capitalize(review.reviewer.name[0])}</span>
                      </Grid>
                    </Avatar>
                  </Grid>
                </Grid>
                <Grid className={classes.flex1} item key="{review.reviewer.name}">
                  <Grid
                    container
                    justify="flex-start"
                    alignItems="center"
                    className={classes.mb15}
                  >
                    <Typography className={classes.userName}>
                      {review.reviewer.name}
                    </Typography>
                    <Typography className={classes.userType}>
                      {this.printCapitaliseString(review.reviewer.type)}
                    </Typography>
                    <Typography className={classes.msgTime}>
                      {dateService.timeSince(review.createdAt)}
                    </Typography>
                  </Grid>
                  <Grid container justify="flex-start">
                    <Typography
                      className={classes.msgDetail}
                      dangerouslySetInnerHTML={{ __html: review.issueDescription }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item className={classes.textRight}>
              <Grid
                container
                className={classes.minHeight91}
                justify="flex-end"
                alignItems="center"
              >
                <Typography className={classes.CTA}>
                  <span
                    onClick={() => onViewFull(viewIndex)}
                    className={classes.popupLink}
                  >
                    View Challenge
                  </span>
                  &nbsp;
                  <img src="/assets/svg/chevron.svg" />
                </Typography>
                <Typography className={classes.status}>
                  {this.printCapitaliseString(review.status)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles)(NotificationListing);
